import { ConversationMessageDispatchStatus } from '@provision/conversation-types';
import type { ConversationMessageDispatch } from '@provision/entity-types';
import dayjs from 'dayjs';

type DispatchStatusFields = Pick<
  ConversationMessageDispatch,
  'dispatchStatus' | 'createdAt' | 'updatedAt'
>;

const DELIVERY_TIMEFRAME_HOURS = 1;

export const getEffectiveDispatchStatus = ({
  dispatchStatus,
  createdAt,
  updatedAt,
}: DispatchStatusFields): ConversationMessageDispatchStatus => {
  const status = dispatchStatus as ConversationMessageDispatchStatus;
  const isDispatching = status === ConversationMessageDispatchStatus.Dispatching;
  const lastUpdatedAt = updatedAt || createdAt;
  const isWithinDeliveryTimeframe = dayjs(lastUpdatedAt).isSameOrAfter(
    dayjs().subtract(DELIVERY_TIMEFRAME_HOURS, 'hour'),
  );

  if (isDispatching && !isWithinDeliveryTimeframe) {
    return ConversationMessageDispatchStatus.Failed;
  }

  return status;
};

export const hasFailedDispatch = (dispatches: DispatchStatusFields[]): boolean =>
  dispatches.some(
    (dispatch) =>
      getEffectiveDispatchStatus(dispatch) === ConversationMessageDispatchStatus.Failed,
  );
